var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("virtual-assistant-lib", {
    attrs: {
      "download-service": _vm.downloadService,
      "get-citation-file-service": _vm.getCitationFileService,
      "send-chat-service": _vm.sendChatService,
      "user-full-name": _vm.userFullName
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }